
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 4.5v-4m0 0H15a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3.5v-2zm-11 23h23m-21-3h5v3h-6v-2a1 1 0 011-1v0zm13 0h5a1 1 0 011 1v2h-6v-3zm-7.5-5h7a.5.5 0 01.354.146.5.5 0 01.146.354v7.5h-8V16a.5.5 0 01.5-.5v0zm3.5 0v8","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.5 20.5v-8h18v8m-19-10h20v1a1 1 0 01-1 1h-18a1 1 0 01-1-1v-1zm20 0l.915-1.829a.81.81 0 00-.33-1.068.81.81 0 00-.394-.103H16.5l-.336-.5a5.606 5.606 0 00-7.309-1.833A5.606 5.606 0 006.836 7l-.336.5H1.309a.81.81 0 00-.724 1.171L1.5 10.5","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    